import React from 'react';


class Comp extends React.Component {
	render() {
    let styleOuter = {
      position:'relative',
      display:'inline-block',
      margin:'3px',
      padding:'5px 10px',
      background:'#DDD',
      textAlign:'left',
      zIndex:'10',
      color:'#666',
			borderRadius:'12px',
      fontSize:'0.9em',
    }

		let styleArrow = {
      position: 'absolute',
  		content: ' ',
  		top: '-10px',
  		right: '50%',
      marginLeft: '5px',
  		borderStyle: 'solid',
  		borderWidth: '0px 6px 12px 6px',
  		borderColor: 'transparent transparent #ddd transparent',
    }

		return (
			<div style={styleOuter}>
        <div style={styleArrow} />
        {this.props.children}
			</div>
		)
	}
}

export default Comp;
